<template>
  <img v-if="url" :src="url" :alt="alt" @error="intento++" />
  <div
    v-else
    role="img"
    :aria-label="alt || 'Producto sin foto'"
    class="flex justify-center items-center bg-base-gray-mediumLight"
    :class="placeholderClass"
  >
    <base-icon name="photo" class="text-[#B1B1B1]" :class="iconClass" />
  </div>
</template>

<script>
import BaseIcon from '@/components/Base/BaseIcon.vue'

const CDN = 'https://d1muroswscgwdh.cloudfront.net/'

// Foto de producto con placeholder si no tiene imagen o si la URL falla al cargar.
// Con `miniatura` pide primero thumbs-julmar/ y, si no existe, la original.
// Las clases que recibe (tamaño, object-fit, @click) van tanto a la foto como al placeholder.
export default {
  name: 'ProductImage',
  components: { BaseIcon },
  props: {
    // Nombre del archivo en el CDN (product.image)
    image: { type: String, default: '' },
    // URL completa, para los lugares que ya la traen armada
    src: { type: String, default: '' },
    // Para listados: fotos chicas, no usar en la ficha grande
    miniatura: { type: Boolean, default: false },
    alt: { type: String, default: '' },
    iconClass: { type: String, default: 'h-6 w-6' },
    // Solo para el placeholder: alto cuando la foto se dimensiona sola (h-auto)
    placeholderClass: { type: String, default: '' }
  },
  data() {
    return {
      intento: 0
    }
  },
  computed: {
    urls() {
      if (this.src) return [this.src]
      if (!this.image) return []
      const original = CDN + this.image
      return this.miniatura && this.image.startsWith('julmar/')
        ? [CDN + 'thumbs-julmar/' + this.image.slice('julmar/'.length), original]
        : [original]
    },
    url() {
      return this.urls[this.intento] || ''
    }
  },
  watch: {
    // Las filas de las tablas reutilizan el componente al cambiar de producto
    urls() {
      this.intento = 0
    }
  }
}
</script>
